import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './StripePages.css';

function RefreshPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source') === 'mobile' ? 'mobile' : 'web';
  const appReturnUrl = searchParams.get('app_return') || 'fodyfee://stripe/return';
  const mobileQuery = `source=mobile&app_return=${encodeURIComponent(appReturnUrl)}`;

  const handleRetry = () => {
    navigate(source === 'mobile' ? `/stripe/return?${mobileQuery}` : '/stripe/return');
  };

  const handleReturnToApp = () => {
    if (source === 'mobile') {
      window.location.href = appReturnUrl;
      return;
    }
    navigate('/admin/account');
  };

  return (
    <div className="stripe-page info">
      <div className="stripe-card">
        <div className="info-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4M12 8h.01" />
          </svg>
        </div>
        <h1>Session Expired</h1>
        <p>Your Stripe session has expired. Please try again to complete your account setup.</p>
        <div className="button-group">
          <button onClick={handleRetry} className="secondary-button">
            Try Again
          </button>
          <button onClick={handleReturnToApp} className="primary-button">
            Return to Account
          </button>
        </div>
      </div>
    </div>
  );
}

export default RefreshPage;
